export const BLOCK_CHAIN_LIBRARY = "blockchainLibrary";
export const BLOCK_CHAIN_ACCOUNT = "blockchainAccount";
export const WALLET_NAME = "walletName";
export const REFER_ADDRESS = "referAddree";
export const DEAD_LINE = "deadLine";
export const IS_ADMIN = "isAdmin";
export const IS_FOLLOW_INSTAGRAM = "isFollowInstagram";
export const IS_FOLLLOW_TELEGRAM = "isFollowTelegram";
export const IS_FOLLOW_TWITTER = "isFollowTwitter";
